module.exports = __webpack_public_path__ + "d08f967f720c0199ab757e888adc1582.pdf";